export default "__VITE_ASSET__13ecd3b7__"